import React from 'react'
import CustomListItemFormItems from '../../../../components/CustomListItemFormItems'
import { CustomFieldDataType } from '@cims-online/shared'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import ReportIdsFormItem from '../../../../components/ReportIdsFormItem'
import EntityIdsFormItem from '../../../../components/EntityIdsFormItem'
import CustomFieldToClassTypeFormItems from '../../../../components/CustomFieldToClassTypeFormItems'
import { ProjectCustomField } from 'components/CustomFields/ProjectCustomFieldsContext/types'
import { HelpMessage } from 'utils/constants'

const EditCustomFieldModalBody: React.FC<
  Pick<ProjectCustomField, 'dataTypeId' | 'customFieldToClassTypes'>
> = ({ dataTypeId, customFieldToClassTypes }) => {
  return (
    <>
      <NameFormItem help={HelpMessage.Administration.CustomFields.Name} />
      <DescriptionFormItem entityName="Custom Field" />
      {dataTypeId === CustomFieldDataType.List.id && (
        <CustomListItemFormItems />
      )}
      {dataTypeId === CustomFieldDataType.Report.id && <ReportIdsFormItem />}
      {dataTypeId === CustomFieldDataType.Entity.id && <EntityIdsFormItem />}
      <CustomFieldToClassTypeFormItems
        customFieldToClassTypes={customFieldToClassTypes}
      />
    </>
  )
}

export default EditCustomFieldModalBody
